import { render, staticRenderFns } from "./FormSubmissionMessage.vue?vue&type=template&id=90d6b9b6&scoped=true&"
import script from "./FormSubmissionMessage.vue?vue&type=script&lang=ts&"
export * from "./FormSubmissionMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d6b9b6",
  null
  
)

export default component.exports